/**
 * Vantage Bundle & Save — keeps the Shopify discount code in sync with cart contents.
 *
 * The discounts themselves are Buy X Get Y *code* discounts created in Admin
 * (buys 1+ from the Cases collection, gets % off the configured accessories),
 * so Shopify enforces the phone-case prerequisite and unit caps at checkout.
 * This script only decides WHICH code should be attached:
 *   - 1 distinct configured accessory in cart  -> 5% code
 *   - 2 distinct configured accessories        -> 10% code
 *   - no accessory or no phone case            -> no bundle code
 *
 * Config comes from the #vg-bundle-config JSON rendered in layout/theme.liquid.
 */
(function () {
  var cfgEl = document.getElementById('vg-bundle-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var ourCodes = [cfg.code5, cfg.code10].filter(Boolean);
  if (ourCodes.length < 2 || !(cfg.accessories || []).length) return;
  var busy = false;

  function pillCodes() {
    return Array.prototype.map
      .call(document.querySelectorAll('.cart-discount__pill'), function (el) { return el.dataset.discountCode; })
      .filter(Boolean);
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var distinct = {};
        var casePresent = false;
        (cart.items || []).forEach(function (item) {
          if (cfg.accessories.indexOf(item.product_id) > -1) distinct[item.product_id] = true;
          var role = item.properties && item.properties._vg_role;
          /* ponytail: case detection = our stamped property or product type;
             a case matched only by tag is caught server-side by the BXGY prerequisite */
          if (role === 'case' || (cfg.caseTypes || []).indexOf(item.product_type) > -1) casePresent = true;
        });
        var n = Object.keys(distinct).length;
        var desired = null;
        if (casePresent && n >= 2) desired = cfg.code10;
        else if (casePresent && n === 1) desired = cfg.code5;

        var codes = cart.discount_codes
          ? cart.discount_codes.map(function (c) { return c.code; })
          : pillCodes();
        var target = codes.filter(function (c) { return ourCodes.indexOf(c) === -1; });
        if (desired) target.push(desired);
        if (target.join(',') === codes.join(',')) {
          busy = false;
          return;
        }

        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });
        var body = { discount: target.join(',') };
        if (sectionIds.length) body.sections = sectionIds.join(',');
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            busy = false;
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: resp,
                sourceId: 'vg-bundle',
                data: { source: 'vg-bundle', sections: resp.sections }
              }
            }));
          });
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.data && e.detail.data.source === 'vg-bundle') return;
    reconcile();
  });

  /* clean up a stale bundle code left over from a previous visit */
  if (pillCodes().some(function (c) { return ourCodes.indexOf(c) > -1; })) reconcile();
})();
